import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {GetAppTwoTone} from "@material-ui/icons";
import Link from "@material-ui/core/Link";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(name, description, downloadLink) {
    return { name, description, downloadLink };
}

const rows = [
    createData('ISO 27001:2022', "Information security, cybersecurity and privacy protection - Information security management systems - Requirements", undefined),
];

class References extends Component {
    render() {
        return <div>
            <Typography component="h2" variant="h5">
                REFERENCES
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                        {rows.map(row => (
                            <TableRow key={row.name}>
                                <TableCell component="th" scope="row">
                                    {row.name}
                                </TableCell>
                                <TableCell>{row.description}</TableCell>
                                <TableCell>{row.downloadLink && <Link href={row.downloadLink} download><GetAppTwoTone/></Link>}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </div>;
    }
}

export default withStyles(classes)(References);